import { Component, Inject, OnInit } from '@angular/core';
import { DialogService } from '@app/common/services/dialog.service';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { createSupplier, ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import { HelpService } from '@app/common/services/help.service';
import { Restangular } from 'ngx-restangular';

@Component({
  selector: 'supplier-edit',
  templateUrl: './supplier-edit.component.html',
})
export class SupplierEditComponent implements OnInit {

  supplierId: number;
  supplier: ProjectSubjectModel;
  loading = true;
  helpIds = HelpService.HELP_IDS;

  constructor(
    private restangular: Restangular,
    private dialogService: DialogService,
    private config: DialogConfig,
    private dialog: DialogRef,
  ) {
    this.supplierId = (<DialogConfigData>config.data).supplierId;
    this.onCreate = this.onCreate.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  ngOnInit() {
    if (this.supplierId) {
      this.restangular
        .one('suppliers', this.supplierId)
        .get()
        .toPromise()
        .then(data => {
          this.supplier = data.plain();
          this.loading = false;
        });
    } else {
      this.supplier = createSupplier();
      this.loading = false;
    }
  }

  onCreate(): Promise<any> {
    return this.restangular
      .all('suppliers')
      .all('create')
      .post(this.supplier)
      .toPromise()
      .then(data => {
        this.dialog.close(data.plain());
      });
  }

  onUpdate(): Promise<any> {
    return this.restangular
      .one('suppliers', this.supplier.id)
      .customPUT(this.supplier, '', {})
      .toPromise()
      .then(data => {
        this.dialog.close(data.plain());
      });
  }

  isValid() {
    const companyTypes = ['OPO', 'OPO_OSS', 'OPO_PO'];
    const isCompany = this.supplier.companyName && companyTypes.includes(this.supplier.subjectType);
    const isPerson = this.supplier.surname && this.supplier.subjectType === 'OFO';
    return isCompany || isPerson;
  }
}
